import { P, FF } from "../../styles/tokens";
import { useFinancial } from "../../contexts/FinancialContext";
import { fmt } from "../../utils/format";

export default function MobileHero() {
  const {
    capitalReal, hasCuentas,
    saldoEfectivo, saldoDebito, saldoVales,
    flujoDisponible,
    comprometido,
  } = useFinancial();

  const flujoSano = capitalReal - (comprometido?.fijosSinPagar || 0) - (comprometido?.tdcPendiente || 0);

  return (
    <div style={{ padding:"14px 16px 12px" }}>
      <div data-tour="hero" style={{ background:"#143D2E", borderRadius:20, padding:"16px 18px 16px" }}>
        {hasCuentas ? (
          <>
            {/* Capital disponible */}
            <div style={{ fontSize:9, fontWeight:800, color:"rgba(255,255,255,0.75)", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:6, fontFamily:FF }}>Tu dinero</div>
            <div style={{ fontSize:36, fontWeight:900, color:"#fff", fontFamily:FF, letterSpacing:"-1.5px", lineHeight:1, marginBottom:12, fontVariantNumeric:"tabular-nums" }}>
              <sup style={{ fontSize:18, fontWeight:600, verticalAlign:"super" }}>$</sup>
              {Math.round(Math.abs(capitalReal)).toLocaleString("es-MX")}
            </div>

            {/* Tarjetas de cuentas */}
            <div style={{ display:"flex", gap:8, flexWrap:"wrap", marginBottom:14 }}>
              {[
                { label:"Efectivo", val:saldoEfectivo },
                { label:"Débito", val:saldoDebito },
                { label:"Vales", val:saldoVales },
              ].filter(t => t.val > 0).map(t => (
                <div key={t.label} style={{ background:"rgba(255,255,255,0.1)", borderRadius:10, padding:"5px 12px" }}>
                  <div style={{ fontSize:8, fontWeight:700, color:"rgba(255,255,255,0.75)", textTransform:"uppercase", letterSpacing:"0.08em" }}>{t.label}</div>
                  <div style={{ fontSize:14, fontWeight:900, color:"#fff", fontFamily:FF, fontVariantNumeric:"tabular-nums" }}>${Math.round(t.val).toLocaleString("es-MX")}</div>
                </div>
              ))}
            </div>

            {/* Separador */}
            <div style={{ height:1, background:"rgba(255,255,255,0.12)", marginBottom:14 }} />

            {/* Flujo sano */}
            <div>
              <div style={{ fontSize:9, fontWeight:800, color:"rgba(255,255,255,0.75)", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:4, fontFamily:FF }}>Si pagas todo, te queda</div>
              <div style={{ fontSize:24, fontWeight:900, color: flujoSano >= 0 ? P.success.light : "#FCA5A5", fontFamily:FF, letterSpacing:"-1px", lineHeight:1, fontVariantNumeric:"tabular-nums" }}>
                {fmt(flujoSano)}
              </div>
              <div style={{ fontSize:9, color:"rgba(255,255,255,0.7)", fontFamily:FF, marginTop:6 }}>Después de cubrir fijos y TDC pendientes</div>
            </div>
          </>
        ) : (
          <>
            <div style={{ fontSize:9, fontWeight:800, color:"rgba(255,255,255,0.75)", textTransform:"uppercase", letterSpacing:"0.08em", marginBottom:6, fontFamily:FF }}>Flujo disponible</div>
            <div style={{ fontSize:36, fontWeight:900, color: flujoDisponible < 0 ? "#FCA5A5" : "#fff", fontFamily:FF, letterSpacing:"-1.5px", lineHeight:1, fontVariantNumeric:"tabular-nums" }}>
              <sup style={{ fontSize:18, fontWeight:600, verticalAlign:"super" }}>$</sup>
              {Math.abs(flujoDisponible).toLocaleString("es-MX")}
            </div>
          </>
        )}
      </div>
    </div>
  );
}
